import React from 'react'

const LoadingView = props => {
  return <div></div>
}

export default LoadingView
